import React from 'react';
import { Link } from 'react-router-dom';

export default function PhotovoltaiquePage() {
  return (
    <>
      {/* Hero */}
      <section className="page-hero" style={{ background: "linear-gradient(rgba(0,0,0,0.5), rgba(0,0,0,0.5)), url('/assets/images/PAGEPANNEAUXPHOTOVOLTAIQUE.jpg') center/cover" }}>
        <div className="container" style={{ width: '100%' }}>
          <div className="hero-content">
            <h1 className="hero-title">Panneaux Solaires <span className="text-accent">Photovoltaïques</span></h1>
            <p className="hero-subtitle">Transformez la luminosité du soleil en électricité. Consommez votre propre énergie et faites jusqu'à <strong>80% d'économies</strong> sur votre facture d'électricité.</p>
            <div className="hero-buttons" style={{ justifyContent: 'center', maxWidth: '400px', margin: '0 auto' }}>
              <Link to="/#contact" className="btn btn-primary" style={{ padding: '14px 28px', fontSize: '1rem' }}>Demander un devis gratuit</Link>
              <a href="tel:0465845177" className="phone-number" style={{ color: 'white', borderColor: 'white' }}>04 65 84 51 77</a>
            </div>
          </div>
        </div>
      </section>

      {/* Advantages */}
      <section className="advantages-section">
        <div className="container">
          <div className="section-header">
            <h2>Pourquoi choisir le <span className="text-accent">photovoltaïque</span> ?</h2>
          </div>
          <div className="advantages-grid">
            {[
              { icon: '☀️', title: "Jusqu'à 80% d'économies", text: "Réduisez drastiquement vos factures d'électricité en produisant votre propre énergie verte et gratuite." },
              { icon: '🌿', title: 'Énergie 100% verte', text: "Contribuez à la protection de l'environnement en utilisant une énergie propre et renouvelable." },
              { icon: '📈', title: 'Valorisation immobilière', text: "L'installation de panneaux solaires augmente la valeur de votre bien immobilier et améliore son diagnostic énergétique." },
              { icon: '🛡️', title: 'Garantie 25 ans', text: "Nos panneaux sont garantis 25 ans sur la performance et 10 ans sur le matériel. Un investissement durable." },
            ].map((a) => (
              <div className="advantage-card" key={a.title}>
                <div className="advantage-icon">
                  <svg width="40" height="40" viewBox="0 0 24 24" fill="currentColor"><path d="M12 2L13.09 8.26L20 9L13.09 9.74L12 16L10.91 9.74L4 9L10.91 8.26L12 2Z"/></svg>
                </div>
                <h3>{a.title}</h3>
                <p>{a.text}</p>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* Products */}
      <section className="products-section">
        <div className="container">
          <div className="section-header">
            <h2>Nos solutions <span className="text-accent">photovoltaïques</span></h2>
            <p>Des installations adaptées à votre consommation et votre type de toiture</p>
          </div>
          <div className="products-grid">
            {[
              {
                img: '/assets/images/AdobeStock_229796072.jpeg',
                title: 'Kit Essentiel — 3 kWc',
                desc: 'Idéal pour les petites consommations. Installation sur toiture inclinée, kit complet avec onduleur.',
                specs: [{ v: '6', l: 'Panneaux' }, { v: '3 kWc', l: 'Puissance' }, { v: '70%', l: 'Économies' }, { v: '25 ans', l: 'Garantie' }],
              },
              {
                img: '/assets/images/AdobeStock_208731473.jpeg',
                title: 'Kit Standard — 6 kWc',
                desc: 'La solution la plus populaire pour une maison familiale. Autoconsommation optimisée.',
                specs: [{ v: '12', l: 'Panneaux' }, { v: '6 kWc', l: 'Puissance' }, { v: '75%', l: 'Économies' }, { v: '25 ans', l: 'Garantie' }],
                featured: true,
              },
              {
                img: '/assets/images/PANNEAUX_JOUR.jpg',
                title: 'Kit Premium — 9 kWc',
                desc: 'Pour les grandes maisons ou les fortes consommations. Avec option stockage batterie.',
                specs: [{ v: '18', l: 'Panneaux' }, { v: '9 kWc', l: 'Puissance' }, { v: '80%', l: 'Économies' }, { v: '25 ans', l: 'Garantie' }],
              },
            ].map((p) => (
              <div className={`product-card ${p.featured ? 'featured' : ''}`} key={p.title}>
                {p.featured && <div className="product-badge">Le plus populaire</div>}
                <div className="product-image"><img src={p.img} alt={p.title} /></div>
                <div className="product-content">
                  <h3>{p.title}</h3>
                  <p className="product-description">{p.desc}</p>
                  <div className="product-specs-grid">
                    {p.specs.map((s) => (<div className="spec-item" key={s.l}><div className="spec-value">{s.v}</div><div className="spec-label">{s.l}</div></div>))}
                  </div>
                  <Link to="/#contact" className="btn btn-primary" style={{ display: 'block', textAlign: 'center' }}>Demander un devis</Link>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* Process */}
      <section className="installation-process">
        <div className="container">
          <div className="section-header">
            <h2>Notre processus <span className="text-accent">d'installation</span></h2>
          </div>
          <div className="process-steps">
            {[
              { n: 1, title: 'Étude de faisabilité', text: "Analyse de votre toiture, orientation, consommation et simulation de production." },
              { n: 2, title: 'Démarches administratives', text: "Déclaration préalable de travaux, demande de raccordement Enedis, dossier CEE/MaPrimeRénov." },
              { n: 3, title: 'Installation', text: "Pose des panneaux par nos techniciens certifiés RGE en 1 à 2 jours." },
              { n: 4, title: 'Mise en service', text: "Raccordement au réseau, configuration du suivi de production, démonstration." },
            ].map((s) => (
              <div className="process-step" key={s.n}>
                <div className="step-number">{s.n}</div>
                <h3>{s.title}</h3>
                <p>{s.text}</p>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* CTA */}
      <section className="cta-section">
        <div className="container">
          <h2>Prêt à passer au solaire ?</h2>
          <p>Obtenez votre étude personnalisée gratuite et sans engagement</p>
          <div className="cta-buttons">
            <Link to="/#contact" className="btn btn-white" style={{ padding: '14px 30px', fontSize: '1rem' }}>Demander mon devis gratuit</Link>
            <a href="tel:0465845177" className="btn-outline-white" style={{ padding: '14px 30px', fontSize: '1rem' }}>Appeler le 04 65 84 51 77</a>
          </div>
        </div>
      </section>
    </>
  );
}
